export const PARTNER_FORM_THESIS = {
  tag: "PARTNER ACCESS GATE",
  status: "OPEN ENROLLMENT",
  headline: "Five fields. Two minutes.",
  headlineAccent: "Full partner dashboard access.",
  insight:
    "No sales calls, no waiting lists. Submit your agency credentials and log straight into the wholesale deployment console.",
};

export const PARTNER_SCAN = [
  { value: "5", label: "Fields Only", sub: "no lengthy intake" },
  { value: "~2 min", label: "To Complete", sub: "average fill time" },
  { value: "Instant", label: "Dashboard", sub: "access on submit" },
];

export const UNLOCK_STEPS = [
  {
    step: "01",
    title: "Issue credentials",
    description: "Name, work email, agency URL, client base, and niche. That's the entire intake.",
    icon: "key",
  },
  {
    step: "02",
    title: "Enter partner dashboard",
    description: "Immediate login to your wholesale console. Review 3 infrastructure tiers, pooled credits, and deployment slots.",
    icon: "dashboard",
  },
  {
    step: "03",
    title: "Deploy first client Digital Assistant",
    description: "Match a client to Tier 1, 2, or 3 and activate their Digital assistant under your brand. Credits roll into your agency pool.",
    icon: "rocket",
  },
];

export const FORM_FIELDS = [
  { name: "name", label: "Your Name", placeholder: "Enter your full name", type: "text", required: true },
  { name: "email", label: "Company Work Email", placeholder: "name@youragency.com", type: "email", required: true },
  { name: "website", label: "Agency Website URL", placeholder: "www.youragency.com", type: "url", required: false },
  { name: "clientBase", label: "Current Active Client Base", type: "select", required: true },
  { name: "niche", label: "Primary Niche / Industry Focus", placeholder: "e.g., Home Services, Real Estate, Medical", type: "text", required: true },
];
